/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../styles/Login.css';

const OAuthError = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const errorMessage = searchParams.get('message') || 'An error occurred during authentication.';

  return (
    <div className="login-container" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="login-box" style={{ textAlign: 'center', maxWidth: '500px' }}>
        <FontAwesomeIcon
          icon={faExclamationCircle}
          style={{ fontSize: '64px', color: '#e74c3c', marginBottom: '20px' }}
        />
        <h2 style={{ color: '#e74c3c', marginBottom: '10px' }}>Authentication Error</h2>
        <p style={{ color: '#666', marginBottom: '30px' }}>
          {errorMessage}
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={() => navigate('/login')}
            style={{
              padding: '12px 24px',
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            Back to Login
          </button>
          <button
            onClick={() => navigate('/signup')}
            style={{
              padding: '12px 24px',
              background: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Try Signup Instead
          </button>
        </div>
      </div>
    </div>
  );
};

export default OAuthError;
